import React from "react";
import { Entry } from "../../GratefulDB";
import DownloadButton from "../shared/DownloadButton";
import ShareButton from "../shared/ShareButton";
import "./EntryTags.scss";
import MaxWidthLabel from "./MaxWidthLabel";

const EntryTags: React.FC<{
  entry: Entry;
  showShareButton?: boolean;
  showDownloadButton?: boolean;
}> = (props): JSX.Element => {
  return (
    <div className="EntryTags">
      <div className={`ui label ${props.entry.isSoundboard ? "teal" : ""}`}>
        {props.entry.isSoundboard ? "SBD" : "AUD"}
      </div>
      <MaxWidthLabel label={props.entry.transferer} width={40} />
      {props.entry.artist ? (
        <div className="ui label">{props.entry.artist}</div>
      ) : null}
      {props.showShareButton && <ShareButton showId={props.entry.identifier} />}
      {props.showDownloadButton && (
        <DownloadButton showId={props.entry.identifier} />
      )}
    </div>
  );
};

export default EntryTags;
